/* eslint-disable import/extensions */
export { SupportSummary } from "./src/views/SupportSummary.jsx";
export { SupportButton } from "./src/views/SupportButton.jsx";

// Also provide a default export with both components
import { SupportSummary } from "./src/views/SupportSummary.jsx";
import { SupportButton } from "./src/views/SupportButton.jsx";

export default {
  SupportSummary,
  SupportButton
};